import {
  GET_CURRENT_FOCUS,
  GET_UPCOMING_CONTENT,
  GET_RECENT_PUBLISHED,
  PUBLIC_CONTENT_LOADING,
} from "../actions/types";

const initialState = {
  currentFocus: null,
  upcoming: [],
  recentPublished: [],
  loading: false,
};

export default function publicContentReducer(state = initialState, action) {
  switch (action.type) {
    case PUBLIC_CONTENT_LOADING:
      return { ...state, loading: true };

    case GET_CURRENT_FOCUS:
      return { ...state, currentFocus: action.payload, loading: false };

    case GET_UPCOMING_CONTENT:
      return { ...state, upcoming: action.payload, loading: false };

    case GET_RECENT_PUBLISHED:
      return { ...state, recentPublished: action.payload, loading: false };

    default:
      return state;
  }
}
